import { createAction, props } from "@ngrx/store";

export const SAVE_PUSH_NOTIFICATION_TOKEN = '[Push Notification] Save push notification token';
export const SAVE_PUSH_NOTIFICATION_TOKEN_SUCCESS = '[Push Notification] Save push notification token success';
export const SAVE_PUSH_NOTIFICATION_TOKEN_FAIL = '[Push Notification] Save push notification token fail';

export const savePushNotificationToken = createAction(SAVE_PUSH_NOTIFICATION_TOKEN, props<{ memberId: number }>());
export const savePushNotificationTokenSuccess = createAction(SAVE_PUSH_NOTIFICATION_TOKEN_SUCCESS);
export const savePushNotificationTokenFail = createAction(SAVE_PUSH_NOTIFICATION_TOKEN_FAIL);